module.exports = {
  '@primary-color': '#FFD457',
  '@link-color': '#FFD457',
  '@redMain': '#FFD457',
  '@greyDark': '#D5D5D5',
  '@btn-text-color': '#000000'
};
